module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cellBox weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('dof-cell', {
    key: 'cellIsColmo' + _vm._isColmo,
    attrs: {
      "title": _vm.title,
      "hasArrow": false,
      "hasTopBorder": false,
      "hasSubTopBorder": false,
      "hasBottomBorder": false,
      "hasSubBottomBorder": false,
      "backgroundColor": _vm.backgroundColor,
      "disabled": _vm.disabled,
      "data-evt-dofCellClicked": ""
    },
    on: {
      "dofCellClicked": _vm.dofCellClick
    }
  }, [(_vm.radioIcon && _vm._isColmo) ? _c('dof-iconfont', {
    attrs: {
      "slot": "switch",
      "code": '\u4729',
      "size": 50,
      "color": 'rgba(255, 255, 255, 0.8)'
    },
    slot: "switch"
  }) : _vm._e(), _vm._v(" "), (_vm.radioIcon && !_vm._isColmo) ? _c('figure', {
    staticClass: "radio weex-el weex-image",
    attrs: {
      "slot": "switch",
      "src": _vm.radioIcon,
      "data-img-src": _vm.radioIcon,
      "weex-type": "image"
    },
    slot: "switch"
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.isLast && _vm.isShowBorder) ? _c('div', {
    staticClass: "fakeStyle weex-ct weex-div",
    style: ({
      backgroundColor: _vm._isColmo ? 'rgba(255, 255, 255, 0.14)' : '#dddddd',
      right: _vm._px2rem(_vm.isFullBorder ? '0px' : '24px', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3ae469c8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ae469c8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-radio-list/radio-item.vue
// module id = 604
// module chunks = 0 1